// ======================================================================
// 📁 RoutingHeaderForm.jsx
// ======================================================================

import React, { useEffect, useState } from "react";
import axiosClient from "../../../../../api/axiosClient";

export default function RoutingHeaderForm({
  value,
  onChange,
  disabled = false,
}) {
  const [productFamilies, setProductFamilies] = useState([]);
  const [equipmentList, setEquipmentList] = useState([]);

  // ------------------------------------------------------------
  // Load Product Families
  // ------------------------------------------------------------
  useEffect(() => {
    axiosClient
      .get("/api/ppe/masters/product-families")
      .then((res) => {
        setProductFamilies(res.data?.data || []);
      })
      .catch((err) => {
        console.error(
          "Failed to load product families",
          err
        );
        setProductFamilies([]);
      });
  }, []);

  // ------------------------------------------------------------
  // Load Equipment
  // ------------------------------------------------------------
  useEffect(() => {
    axiosClient
      .get("/api/ppe/masters/equipment")
      .then((res) => {
        setEquipmentList(res.data?.data || []);
      })
      .catch((err) => {
        console.error("Failed to load equipment", err);
        setEquipmentList([]);
      });
  }, []);

  // ------------------------------------------------------------
  // Update field (CONTROLLED)
  // ------------------------------------------------------------
  const updateField = (field, valueField) => {
    if (disabled) return;

    onChange({
      ...value,
      [field]: valueField,
    });
  };

  return (
    <div className="card mb-3">
      <div className="card-header">
        <strong>Routing Header</strong>
      </div>

      <div className="card-body">
        <div
          style={{
            display: "grid",
            gridTemplateColumns:
              "1.5fr 2fr 2fr 2fr 1.5fr",
            gap: 16,
          }}
        >
          {/* Routing Code (AUTO) */}
          <input
            className="form-control"
            disabled
            placeholder="Routing Code (auto)"
          />

          {/* Routing Name */}
          <input
            className="form-control"
            placeholder="Routing Name"
            value={value.routing_name}
            disabled={disabled}
            onChange={(e) =>
              updateField(
                "routing_name",
                e.target.value
              )
            }
          />

          {/* Product Family */}
          <select
            className="form-select"
            value={value.product_family_id}
            disabled={disabled}
            onChange={(e) =>
              updateField(
                "product_family_id",
                e.target.value
              )
            }
          >
            <option value="">
              Select Product Family
            </option>
            {productFamilies.map((pf) => (
              <option key={pf.id} value={pf.id}>
                {pf.name} ({pf.code})
              </option>
            ))}
          </select>

          {/* Equipment */}
          <select
            className="form-select"
            value={value.equipment_id || ""}
            disabled={disabled}
            onChange={(e) =>
              updateField(
                "equipment_id",
                e.target.value
              )
            }
          >
            <option value="">
              Select Equipment
            </option>

            {equipmentList.map((eq) => (
              <option key={eq.id} value={eq.id}>
                {eq.name} ({eq.code})
              </option>
            ))}
          </select>

          {/* Routing Type */}
          <select
            className="form-select"
            value={value.routing_type}
            disabled={disabled}
            onChange={(e) =>
              updateField(
                "routing_type",
                e.target.value
              )
            }
          >
            <option value="STANDARD">
              STANDARD
            </option>
            <option value="PROJECT">
              PROJECT
            </option>
          </select>
        </div>
      </div>
    </div>
  );
}